// @ts-nocheck
import { GetCmsLibraryApiParameter } from "@store/Framework/Services/CmsLibraryService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetCmsLibraryApiParameter>;

export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CmsLibrary/UpdateCmsLibraryParameters",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateSearchFields];

const updateCmsLibraryParameters = createHandlerChainRunner(chain, "UpdateCmsLibraryParameters");
export default updateCmsLibraryParameters;
